"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

// Used for checking if the children of an element is only text content.
// By creating a utility here, we can better adapt this later.
var isTextContent = function isTextContent(content) {
  return typeof content === 'string' || Array.isArray(content) && content.every(function (c) {
    return typeof c === 'string';
  });
};

var _default = isTextContent;
exports.default = _default;